import Firework from './Firework';
export default Firework;